// extracted by mini-css-extract-plugin
export var frame = "inline-script-module--frame--7df7d";